import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import ScrollToTop from "@/components/site/ScrollToTop";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";
import KostajaBadge from "@/components/site/KostajaBadge";

import Home from "@/pages/Home";
import ListingStandard from "@/pages/ListingStandard";
import Pricing from "@/pages/Pricing";
import FAQPage from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import InsightsArticle from "@/pages/InsightsArticle";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white text-brand-black">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-brand-black focus:text-white focus:px-4 focus:py-2 focus:rounded"
        data-testid="skip-to-content"
      >
        Skip to content
      </a>
      <Header />
      <main id="main" className="flex-1 pt-16 md:pt-[72px]">{children}</main>
      <MobileStickyCTA />
      <KostajaBadge />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster position="top-center" richColors closeButton />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/listing-standard" element={<ListingStandard />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightsArticle />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
